/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeambulazioneTipoUpdateDTO
 */
export interface DeambulazioneTipoUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof DeambulazioneTipoUpdateDTO
     */
    descrizione?: string;
}

/**
 * Check if a given object implements the DeambulazioneTipoUpdateDTO interface.
 */
export function instanceOfDeambulazioneTipoUpdateDTO(value: object): value is DeambulazioneTipoUpdateDTO {
    return true;
}

export function DeambulazioneTipoUpdateDTOFromJSON(json: any): DeambulazioneTipoUpdateDTO {
    return DeambulazioneTipoUpdateDTOFromJSONTyped(json, false);
}

export function DeambulazioneTipoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeambulazioneTipoUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function DeambulazioneTipoUpdateDTOToJSON(value?: DeambulazioneTipoUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'descrizione': value['descrizione'],
    };
}

